export const isGsm7  = (node) =>  {
    // This regex matches ONLY characters present in the GSM 03.38 default and extension alphabets.
    // Note:
    // 1. We escape special regex characters like - [ ] \ ^
    // 2. It includes \n (Line Feed) and \r (Carriage Return)
    // 3. It includes the Euro symbol (€) and other extension characters
    const gsm7Regex = /^[@£$¥èéùìòÇ\nØø\rÅåΔ_ΦΓΛΩΠΨΣΞÆæßÉ !"#¤%&'()*+,\-./0-9:;<=>?¡A-ZÄÖÑÜ§¿a-zäöñüà^{}\\[~\]|€]*$/;

    return gsm7Regex.test(node.value);
}
